import React, { useState, useEffect } from 'react';
import { Form, Input, InputNumber, Switch, Button, Select, Card, Row, Col, Divider, message } from 'antd';
import { SaveOutlined } from '@ant-design/icons';
import { financeSettingsApi, show422Error, ValidationError } from '../../utils/api';

const { TextArea } = Input;
const { Option } = Select;

const InvoiceGeneralTab = ({ data, onUpdate }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (data?.general) {
      const g = data.general;
      form.setFieldsValue({
        due_after: g.due_after,
        invoice_terms: g.invoice_terms,
        other_info: g.other_info,
        locale: g.locale || 'fa',
        send_reminder: g.send_reminder,
        send_reminder_after: g.send_reminder_after,
        show_gst: g.show_gst === 'yes',
        tax_calculation_msg: !!g.tax_calculation_msg,
        authorised_signatory: !!g.authorised_signatory,
        show_status: !!g.show_status,
        show_project: !!g.show_project,
        show_client_name: g.show_client_name === 'yes',
        show_client_email: g.show_client_email === 'yes',
        show_client_phone: g.show_client_phone === 'yes',
        show_client_company_name: g.show_client_company_name === 'yes',
        show_client_company_address: g.show_client_company_address === 'yes',
      });
    }
  }, [data, form]);

  const handleSubmit = async (values) => {
    setLoading(true);
    try {
      const payload = {
        due_after: values.due_after,
        invoice_terms: values.invoice_terms || '',
        other_info: values.other_info || '',
        locale: values.locale || 'fa',
        send_reminder: values.send_reminder || 0,
        send_reminder_after: values.send_reminder_after || 0,
        show_gst: values.show_gst,
        tax_calculation_msg: values.tax_calculation_msg,
        authorised_signatory: values.authorised_signatory,
        show_status: values.show_status,
        show_project: values.show_project,
        show_client_name: values.show_client_name,
        show_client_email: values.show_client_email,
        show_client_phone: values.show_client_phone,
        show_client_company_name: values.show_client_company_name,
        show_client_company_address: values.show_client_company_address,
      };
      await financeSettingsApi.updateGeneralSettings(payload);
      message.success('تنظیمات عمومی با موفقیت ذخیره شد');
      onUpdate?.();
    } catch (error) {
      console.error('Error updating general settings:', error);
      if (error instanceof ValidationError) {
        show422Error(error, form);
      } else {
        message.error('خطا در ذخیره تنظیمات');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ fontFamily: 'CustomFont' }}>
      <Form form={form} layout="vertical" onFinish={handleSubmit} style={{ fontFamily: 'CustomFont' }}>
        <Card className="mb-4" size="small" title={<span style={{ fontFamily: 'CustomFont' }}>تنظیمات فاکتور</span>}>
          <Row gutter={[16, 0]}>
            <Col xs={24} sm={12} md={8}>
              <Form.Item
                label={<span style={{ fontFamily: 'CustomFont' }}>مهلت پرداخت (روز)</span>}
                name="due_after"
                rules={[{ required: true, message: 'مهلت پرداخت الزامی است' }]}
              >
                <InputNumber min={0} style={{ width: '100%', fontFamily: 'CustomFont' }} placeholder="15" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8}>
              <Form.Item
                label={<span style={{ fontFamily: 'CustomFont' }}>زبان</span>}
                name="locale"
              >
                <Select style={{ fontFamily: 'CustomFont' }}>
                  <Option value="fa">فارسی</Option>
                  <Option value="en">انگلیسی</Option>
                  <Option value="ar">عربی</Option>
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8}>
              <Form.Item
                label={<span style={{ fontFamily: 'CustomFont' }}>ارسال یادآوری</span>}
                name="send_reminder"
              >
                <InputNumber min={0} style={{ width: '100%', fontFamily: 'CustomFont' }} placeholder="0" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8}>
              <Form.Item
                label={<span style={{ fontFamily: 'CustomFont' }}>یادآوری بعد از (روز)</span>}
                name="send_reminder_after"
              >
                <InputNumber min={0} style={{ width: '100%', fontFamily: 'CustomFont' }} placeholder="0" />
              </Form.Item>
            </Col>
          </Row>
        </Card>

        <Card className="mb-4" size="small" title={<span style={{ fontFamily: 'CustomFont' }}>نمایش اطلاعات مشتری</span>}>
          <Row gutter={[24, 8]}>
            <Col xs={24} sm={12} md={8}>
              <Form.Item name="show_client_name" valuePropName="checked" className="mb-2">
                <Switch checkedChildren="نام مشتری" unCheckedChildren="نام مشتری" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8}>
              <Form.Item name="show_client_email" valuePropName="checked" className="mb-2">
                <Switch checkedChildren="ایمیل مشتری" unCheckedChildren="ایمیل مشتری" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8}>
              <Form.Item name="show_client_phone" valuePropName="checked" className="mb-2">
                <Switch checkedChildren="تلفن مشتری" unCheckedChildren="تلفن مشتری" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8}>
              <Form.Item name="show_client_company_name" valuePropName="checked" className="mb-2">
                <Switch checkedChildren="نام شرکت" unCheckedChildren="نام شرکت" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8}>
              <Form.Item name="show_client_company_address" valuePropName="checked" className="mb-2">
                <Switch checkedChildren="آدرس شرکت" unCheckedChildren="آدرس شرکت" />
              </Form.Item>
            </Col>
          </Row>
        </Card>

        <Card className="mb-4" size="small" title={<span style={{ fontFamily: 'CustomFont' }}>گزینه‌های نمایش</span>}>
          <Row gutter={[24, 8]}>
            <Col xs={24} sm={12} md={8}>
              <Form.Item name="show_gst" valuePropName="checked" className="mb-2">
                <Switch checkedChildren="نمایش مالیات" unCheckedChildren="مالیات" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8}>
              <Form.Item name="show_status" valuePropName="checked" className="mb-2">
                <Switch checkedChildren="نمایش وضعیت" unCheckedChildren="وضعیت" />
              </Form.Item>
              <div className="text-xs text-gray-500 leading-6 -mt-1 mb-3" style={{ fontFamily: 'CustomFont' }}>
                این گزینه وضعیت فاکتور (پرداخت شده، پرداخت نشده و پرداخت جزئی) را در فایل PDF فاکتور نمایش می‌دهد.
              </div>
            </Col>
            <Col xs={24} sm={12} md={8}>
              <Form.Item name="show_project" valuePropName="checked" className="mb-2">
                <Switch checkedChildren="نمایش پروژه" unCheckedChildren="پروژه" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8}>
              <Form.Item name="tax_calculation_msg" valuePropName="checked" className="mb-2">
                <Switch checkedChildren="پیام محاسبه مالیات" unCheckedChildren="پیام محاسبه مالیات" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8}>
              <Form.Item name="authorised_signatory" valuePropName="checked" className="mb-2">
                <Switch checkedChildren="امضای مجاز" unCheckedChildren="امضای مجاز" />
              </Form.Item>
              <div className="text-xs text-gray-500 leading-6 -mt-1 mb-3" style={{ fontFamily: 'CustomFont' }}>
                اگر امضا بارگذاری شده و وضعیت فاکتور پرداخت شده باشد، امضای مجاز در PDF فاکتور نمایش داده خواهد شد.
              </div>
            </Col>
          </Row>
        </Card>

        <Card className="mb-4" size="small" title={<span style={{ fontFamily: 'CustomFont' }}>شرایط و توضیحات</span>}>
          <Row gutter={[16, 0]}>
            <Col xs={24} md={12}>
              <Form.Item
                label={<span style={{ fontFamily: 'CustomFont' }}>شرایط فاکتور</span>}
                name="invoice_terms"
              >
                <TextArea rows={4} placeholder="شرایط و ضوابط فاکتور..." style={{ fontFamily: 'CustomFont' }} />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item
                label={<span style={{ fontFamily: 'CustomFont' }}>اطلاعات دیگر</span>}
                name="other_info"
              >
                <TextArea rows={4} placeholder="اطلاعات اضافی..." style={{ fontFamily: 'CustomFont' }} />
              </Form.Item>
            </Col>
          </Row>
        </Card>

        <div className="flex justify-end">
          <Button
            type="primary"
            htmlType="submit"
            icon={<SaveOutlined />}
            loading={loading}
            className="bg-green-600 hover:bg-green-700 border-0"
            style={{ fontFamily: 'CustomFont' }}
          >
            ذخیره تغییرات
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default InvoiceGeneralTab;
